import React from "react";
import { FloatLabel } from "primereact/floatlabel";

export default function InputLayout({
  label,
  name,
  required,
  col,
  extraClassName = "",
  errorMessage,
  data,
  children,
}) {
  col = parseInt(col);
  if (col > 12) {
    col = 12;
  }
  return (
    <div className={`input-layout px-0 md:col-${col} ${extraClassName}`}>
      <label htmlFor={name} className="text-sm font-semibold">
        <div className="mb-1">
          {label}
          {required ? <span className="text-red-500">*</span> : null}
        </div>
      </label>
      {children}
      {errorMessage || data?.formErrors?.[name] ? (
        <small className="p-error">
          {errorMessage || data?.formErrors?.[name]}
        </small>
      ) : null}
    </div>
  );
}

export function FLoatLabelInputLayout({
  label,
  name,
  required,
  col,
  extraClassName = "",
  errorMessage,
  data,
  children,
  labelClassName,
  hideFloatlabel
}) {
  col = parseInt(col);
  if (col > 12) {
    col = 12;
  }
  return (
    <div className={`input-layout mb-2 px-0 md:col-${col} ${extraClassName}`}>
      {!hideFloatlabel ? <FloatLabel>
        {label ? (
          <label
            htmlFor={name}
            className={`text-sm font-semibold z-1 ${labelClassName}`}
          >
            <div className="mb-1">
              {label}
              {required ? <span className="text-red-500">*</span> : null}
            </div>
          </label>
        ) : null}
        {children}
      </FloatLabel> : <>
        {label ? (
          <label
            htmlFor={name}
            className={`text-sm font-semibold z-1 ${labelClassName}`}
          >
            <div className="mb-1">
              {label}
              {required ? <span className="text-red-500">*</span> : null}
            </div>
          </label>
        ) : null}
        {children}
      </>}
      {errorMessage || data?.formErrors?.[name] ? (
        <small className="p-error">
          {errorMessage || data?.formErrors?.[name]}
        </small>
      ) : null}
    </div>
  );
}
